import { type RootState } from "@ds/store/bootstrap";

const selectBaseState = (state: RootState) => state.devices.common;

export const selectCurrentView = (state: RootState) => selectBaseState(state).viewType;
